var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState, useMemo, useCallback } from "react";
import { useSearchParams } from "react-router-dom";
import { Spin, Modal, Form, Input, Button, message } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import { Group, Panel, Separator } from "react-resizable-panels";
import { TeamsMeetingManager } from "../../../components/meeting-gui-hm";
import { useApplicationContext } from "../../../context/application-context";
import apiClientServices, { setAuthorization } from "../../../api-client";
import { MEETING_ENDPOINTS, MS_ADAPTER_ENDPOINTS, } from "../../../utils/endpoints";
import { ensureMeetingSubscription } from "../../../utils/meeting-subscription";
import { decryptText } from "../../../utils/encrypt-decrypt";
import { applyManagerLoginToContext, hydrateManagerUserFromStorage, } from "../../../utils/manager-login-profile";
import HiringFeedbackV2 from "../../../components/hiring-feedback-v2";
import { messages } from "../../../submodules/Inventory-Module-Types/src";
import { loginFlow } from "../../../submodules/Assessment-Platform-1.0-Dtos-FE/src/dtos/userAuthDto";
const meetingPanelStyle = `
  .meeting-panel-container > div {
    width: 100% !important;
    max-width: 100% !important;
  }
`;
const ManagerMeetingUrlBasedAutoLogin = () => {
    var _a, _b;
    const [searchParams] = useSearchParams();
    const { user, setUser, tenantSettings } = useApplicationContext();
    const [loginForm] = Form.useForm();
    const [acsToken, setAcsToken] = useState(null);
    const [msUserId, setMsUserId] = useState(null);
    const [meetingLink, setMeetingLink] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [error, setError] = useState(null);
    const [decryptedPayload, setDecryptedPayload] = useState(null);
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [loginSubmitting, setLoginSubmitting] = useState(false);
    const colorPalette = (_a = tenantSettings === null || tenantSettings === void 0 ? void 0 : tenantSettings.tenantConfig) === null || _a === void 0 ? void 0 : _a.colorPalette;
    const spinnerIndicator = useMemo(() => (_jsx(LoadingOutlined, { style: {
            fontSize: 48,
            color: (colorPalette === null || colorPalette === void 0 ? void 0 : colorPalette.primaryColor) || "#1890ff",
        }, spin: true })), [colorPalette === null || colorPalette === void 0 ? void 0 : colorPalette.primaryColor]);
    // Function to decrypt and extract meeting data from link parameter
    const decryptMeetingData = () => {
        try {
            let link = searchParams.get("link");
            if (!link) {
                // Try to get from sessionStorage (stored during login init)
                return null;
            }
            if (link) {
                console.log("link in decryptMeetingData:", link);
                // Replace spaces with + (URL encoding)
                link = link.replaceAll(" ", "+");
                // Decrypt the link using the encryption key
                const encryptionKey = process.env.REACT_APP_PUBLIC_FEEDBACK_BIG;
                if (!encryptionKey) {
                    console.error("Encryption key not found in environment variables");
                    return null;
                }
                const stringPayload = decryptText(link, encryptionKey);
                if (!stringPayload) {
                    console.error("Failed to decrypt link");
                    return null;
                }
                const jsonPayload = JSON.parse(stringPayload);
                console.log("jsonPayload in decryptMeetingData:", jsonPayload);
                return jsonPayload;
            }
        }
        catch (error) {
            console.error("Error decrypting meeting data:", error);
        }
        return null;
    };
    // Function to fetch meeting link from API
    const getMeetingUrl = (decryptedData) => __awaiter(void 0, void 0, void 0, function* () {
        var _c, _d, _e, _f, _g;
        try {
            setAuthorization(sessionStorage.getItem("token"));
            // Extract userId, courseId, and stageId from decrypted payload
            // The payload might have uid/cid/sid (decoded) or userId/courseId/stageId (decoded)
            const userId = decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.userId;
            const courseId = decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.courseId;
            const stageId = decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.stageId;
            const tenantId = decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.tenantId;
            const hmId = sessionStorage.getItem("userId");
            if (userId && stageId && courseId) {
                console.log("userId, stageId, courseId, hmId in getMeetingUrl:", userId, stageId, courseId, hmId);
                const response = yield apiClientServices.get(MEETING_ENDPOINTS.GET_HM_MEETING_LINK, 
                // "http://localhost:7034/hiring-manager/meeting-link",
                {
                    params: Object.assign({ userId: userId.toString(), stageId: stageId.toString(), courseId: courseId.toString(), tenantId: tenantId.toString() }, (hmId && { hmId: hmId.toString() })),
                });
                if ((_d = (_c = response === null || response === void 0 ? void 0 : response.data) === null || _c === void 0 ? void 0 : _c.result) === null || _d === void 0 ? void 0 : _d.meetLink) {
                    // Create/renew the Graph webhook subscription for this meeting now that
                    // the interviewer has opened Connect. Subscriptions created at
                    // scheduling time (~1h TTL) have usually expired by the interview, so
                    // doing it here keeps transcript/recording capture live. Fire-and-forget
                    // so it never blocks joining the meeting.
                    const meetingId = (_f = (_e = response === null || response === void 0 ? void 0 : response.data) === null || _e === void 0 ? void 0 : _e.result) === null || _f === void 0 ? void 0 : _f.meetingId;
                    if (meetingId) {
                        void ensureMeetingSubscription(meetingId);
                    }
                    return response.data.result.meetLink;
                }
            }
        }
        catch (error) {
            if (((_g = error === null || error === void 0 ? void 0 : error.response) === null || _g === void 0 ? void 0 : _g.status) === 401) {
                sessionStorage.removeItem("token");
                sessionStorage.removeItem("userId");
                sessionStorage.removeItem(messages.SESSION_INTERVIEW_META_DATA);
                setAuthorization("");
                setShowLoginModal(true);
                setIsLoading(false);
                return null;
            }
            console.error("Error fetching meeting link from API:", error);
        }
        // Fallback to meetingLink from decrypted data if API fails
        return (decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.ml) || (decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.meetingLink) || null;
    });
    const getTeamsRefreshAndAcsTokenByEmail = () => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield apiClientServices({
            method: "POST",
            // url: MS_ADAPTER_ENDPOINTS.EXCHANGE_CODE_AND_ACS_TOKEN,
            url: MS_ADAPTER_ENDPOINTS.GET_TEAMS_REFRESH_AND_ACS_TOKEN_BY_EMAIL,
            // url: "http://localhost:7030/adapter/ms/teams-refresh-token-and-acs-token-by-email",
            data: {
                email: "nuvamawealth@RefactorAcademy.onmicrosoft.com",
                tenantUrl: "http://localhost:3015/manager-ms-login-callback",
            },
        });
        // const response = await axios.post<any>(
        //   MS_ADAPTER_ENDPOINTS.EXCHANGE_CODE_AND_ACS_TOKEN,
        //   {
        //     email: "AC@RefactorAcademy.onmicrosoft.com",
        //     tenantUrl: "http://localhost:3015/manager-ms-login-callback",
        //   },
        //   //       data: {
        //   //   email: "AC@RefactorAcademy.onmicrosoft.com",
        //   //   tenantUrl: "http://localhost:3015/manager-ms-login-callback",
        //   // },
        // );
        return (response === null || response === void 0 ? void 0 : response.data) || null;
    });
    const handlePasswordLoginResponse = (response) => __awaiter(void 0, void 0, void 0, function* () {
        var _h;
        const loginResponse = response.data;
        if (loginResponse.status === 200) {
            const data = loginResponse.result;
            if (!(data === null || data === void 0 ? void 0 : data.access_token) || !(data === null || data === void 0 ? void 0 : data.user_id)) {
                message.error("Failed to create manager session.", 4);
                throw new Error("Invalid session");
            }
            sessionStorage.setItem("token", data.access_token);
            sessionStorage.setItem("userId", data.user_id.toString());
            sessionStorage.setItem("email", data.email);
            sessionStorage.setItem(messages.SESSION_INTERVIEW_META_DATA, JSON.stringify({
                token: data.access_token,
                userId: data.user_id.toString(),
                app: (_h = data === null || data === void 0 ? void 0 : data.tenant) === null || _h === void 0 ? void 0 : _h.assessmentLink,
            }));
            setAuthorization(data.access_token);
            applyManagerLoginToContext(data, setUser);
            return;
        }
        if (loginResponse.status === 401) {
            message.error("Oops! Something's not right. Please double-check your email and password", 4);
        }
        else if (loginResponse.status === 403) {
            message.error("You are trying to login with the incorrect portal URL", 4);
        }
        else if (loginResponse.status === 404) {
            message.error("You are not registered with us. please check your entered email", 4);
        }
        else if (loginResponse.status === 600) {
            message.error("Your account is deactivated by admin. Please contact admin to proceed", 4);
        }
        else {
            message.error("We are facing some issue. Please try after sometime", 4);
        }
        throw new Error("Login failed");
    });
    const loginWithPassword = (email, password, decryptedData) => __awaiter(void 0, void 0, void 0, function* () {
        const tenantId = decryptedData === null || decryptedData === void 0 ? void 0 : decryptedData.tenantId;
        if (!tenantId) {
            message.error("Tenant not found in meeting link payload.");
            throw new Error("Missing tenant");
        }
        try {
            const response = yield apiClientServices({
                method: "POST",
                url: "/connect/login",
                data: {
                    channelType: "Normal",
                    loginFlow: loginFlow.PASSWORD,
                    profileObj: {
                        username: email.toLowerCase(),
                        password: password.toString(),
                    },
                    meetingData: decryptedData,
                    tenantId,
                },
                headers: Object.assign(Object.assign({}, apiClientServices.defaults.headers.common), { tid: tenantId, 
                    // tId: "6",
                    "is-admin-portal": "true" }),
            });
            yield handlePasswordLoginResponse(response);
        }
        catch (err) {
            if (err.response) {
                yield handlePasswordLoginResponse(err.response);
            }
            else {
                message.error("We are facing some issue. Please try after sometime", 4);
            }
            throw err;
        }
    });
    const completeMeetingSetup = useCallback((decryptedData) => __awaiter(void 0, void 0, void 0, function* () {
        try {
            const appAccessToken = sessionStorage.getItem("token");
            if (!appAccessToken) {
                throw new Error("Missing session token.");
            }
            setAuthorization(appAccessToken);
            const [meetingUrl, managerTokenResponse] = yield Promise.all([
                getMeetingUrl(decryptedData),
                getTeamsRefreshAndAcsTokenByEmail(),
            ]);
            if (!meetingUrl) {
                setError("Meeting link not found. Please check the URL parameters.");
                return;
            }
            if (!(managerTokenResponse === null || managerTokenResponse === void 0 ? void 0 : managerTokenResponse.token) || !(managerTokenResponse === null || managerTokenResponse === void 0 ? void 0 : managerTokenResponse.msUserId)) {
                setError("Failed to get meeting token. Please try again.");
                return;
            }
            sessionStorage.setItem("manager_ms_token", managerTokenResponse.token);
            sessionStorage.setItem("manager_ms_user_id", managerTokenResponse.msUserId);
            sessionStorage.setItem("manager_ms_email", managerTokenResponse.email || "");
            sessionStorage.setItem("manager_ms_acs_user_id", managerTokenResponse.acsUserId || "");
            setMeetingLink(meetingUrl);
            setAcsToken(managerTokenResponse.token);
            setMsUserId(managerTokenResponse.msUserId);
        }
        catch (err) {
            console.log("Error initializing meeting:", err);
            setError("Failed to load meeting. Please try again.");
        }
        finally {
            setIsLoading(false);
        }
    }), []);
    const onLoginModalSubmit = (values) => __awaiter(void 0, void 0, void 0, function* () {
        if (!decryptedPayload) {
            return;
        }
        setLoginSubmitting(true);
        try {
            yield loginWithPassword(values.email.trim(), values.password, decryptedPayload);
            setShowLoginModal(false);
            setIsLoading(true);
            yield completeMeetingSetup(decryptedPayload);
        }
        catch (_j) {
            // Errors surfaced via message / handlePasswordLoginResponse
        }
        finally {
            setLoginSubmitting(false);
        }
    });
    useEffect(() => {
        const decryptedData = decryptMeetingData();
        if (!decryptedData) {
            setError("Invalid or missing meeting link. Please check the URL.");
            setIsLoading(false);
            return;
        }
        setDecryptedPayload(decryptedData);
        const emailParam = searchParams.get("email");
        if (emailParam) {
            loginForm.setFieldsValue({ email: emailParam });
        }
        const existingToken = sessionStorage.getItem("token");
        if (existingToken) {
            hydrateManagerUserFromStorage(setUser);
            setIsLoading(true);
            completeMeetingSetup(decryptedData);
        }
        else {
            setShowLoginModal(true);
            setIsLoading(false);
        }
    }, [searchParams, completeMeetingSetup, loginForm]);
    const handleMeetingEnd = () => {
        // Clean up meeting-related temporary params
        sessionStorage.removeItem("manager_meeting_link");
        sessionStorage.removeItem("manager_meeting_link_param");
        console.log("Meeting ended");
    };
    if (showLoginModal) {
        return (_jsx("div", Object.assign({ style: {
                minHeight: "100vh",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                background: "#f0f2f5",
            } }, { children: _jsx(Modal, Object.assign({ title: "Sign in", open: true, closable: false, maskClosable: false, keyboard: false, footer: null, width: 400 }, { children: _jsxs(Form, Object.assign({ form: loginForm, layout: "vertical", onFinish: onLoginModalSubmit }, { children: [_jsx(Form.Item, Object.assign({ name: "email", label: "Email", rules: [
                                { required: true, message: "Please enter your email" },
                                { type: "email", message: "Please enter a valid email" },
                            ] }, { children: _jsx(Input, { autoComplete: "email" }) })), _jsx(Form.Item, Object.assign({ name: "password", label: "Password", rules: [
                                { required: true, message: "Please enter your password" },
                            ] }, { children: _jsx(Input.Password, { autoComplete: "current-password" }) })), _jsx(Form.Item, { children: _jsx(Button, Object.assign({ type: "primary", htmlType: "submit", loading: loginSubmitting, block: true, style: { backgroundColor: "#f04e45", borderColor: "#f04e45" } }, { children: "Sign in" })) })] })) })) })));
    }
    if (isLoading) {
        return (_jsxs("div", Object.assign({ style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            } }, { children: [_jsx(Spin, { size: "large", indicator: spinnerIndicator }), _jsx("div", Object.assign({ style: { marginTop: 16 } }, { children: "Loading meeting..." }))] })));
    }
    if (error) {
        return (_jsxs("div", Object.assign({ style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            } }, { children: [_jsx("div", Object.assign({ style: { color: "red", marginBottom: 16 } }, { children: error })), _jsx("button", Object.assign({ onClick: () => window.location.reload() }, { children: "Retry" }))] })));
    }
    if (!acsToken || !meetingLink || !msUserId) {
        return (_jsxs("div", Object.assign({ style: {
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                height: "100vh",
            } }, { children: [_jsx("div", Object.assign({ style: { marginBottom: 16 } }, { children: "Missing required information. Please try again." })), _jsx("button", Object.assign({ onClick: () => window.location.reload() }, { children: "Retry" }))] })));
    }
    return (_jsxs("div", Object.assign({ style: {
            overflow: "hidden",
            position: "relative",
            height: "calc(100vh - 64px)",
        } }, { children: [_jsx("style", { children: meetingPanelStyle }), _jsxs(Group, Object.assign({ orientation: "horizontal", style: { height: "100%" } }, { children: [_jsx(Panel, Object.assign({ defaultSize: 60, minSize: 60, style: { overflow: "hidden" } }, { children: _jsx("div", Object.assign({ className: "meeting-panel-container", style: {
                                height: "100%",
                                width: "100%",
                                overflow: "hidden",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                            } }, { children: _jsx(TeamsMeetingManager, { userId: {
                                    microsoftTeamsUserId: msUserId,
                                    isAnonymous: false,
                                }, token: acsToken, locator: meetingLink, displayName: user ? `${user.firstName} ${user.lastName}` : "Manager", callInvitationURL: meetingLink, onMeetingEnd: handleMeetingEnd }) })) })), _jsx(Separator, { style: {
                            width: "4px",
                            backgroundColor: "#e0e0e0",
                            cursor: "col-resize",
                            transition: "background-color 0.2s",
                        } }), _jsx(Panel, Object.assign({ defaultSize: 40, minSize: 40, style: { overflow: "auto" } }, { children: _jsx("div", Object.assign({ style: { height: "100%", width: "100%", padding: "0px 10px" } }, { children: _jsx(HiringFeedbackV2, { userId: decryptedPayload === null || decryptedPayload === void 0 ? void 0 : decryptedPayload.userId, courseId: decryptedPayload === null || decryptedPayload === void 0 ? void 0 : decryptedPayload.courseId, stageId: decryptedPayload === null || decryptedPayload === void 0 ? void 0 : decryptedPayload.stageId, panelInterviewId: (_b = decryptedPayload === null || decryptedPayload === void 0 ? void 0 : decryptedPayload.panelInterviewId) !== null && _b !== void 0 ? _b : decryptedPayload === null || decryptedPayload === void 0 ? void 0 : decryptedPayload.interviewId, enableInviteAdditionalHm: true }) })) }))] }))] })));
};
export default ManagerMeetingUrlBasedAutoLogin;
